const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
);

// YENİ: maxWidth prop'u eklendi
const InfoModal = ({ isOpen, onClose, title, children, maxWidth }) => {
    if (!isOpen) return null;

    return (
        <div className="ct-modal-backdrop" onClick={onClose}>
            {/* YENİ: maxWidth style içine dinamik olarak verildi */}
            <div className="ct-modal-dialog" style={{ maxWidth: maxWidth || '500px', width: '95%' }} onClick={e => e.stopPropagation()}>
                
                <div className="ct-modal-header" style={{ alignItems: 'center', borderBottom: '2px solid #f0f0f0' }}>
                    <h5 className="ct-modal-title" style={{ margin: 0, fontSize: '1.4rem', color: '#444', fontWeight: '800' }}>
                        {title}
                    </h5>
                    <button 
                        type="button" 
                        onClick={onClose}
                        style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: '#999', padding: '5px', display: 'flex', alignItems: 'center', transition: 'color 0.2s' }}
                        onMouseOver={(e) => e.currentTarget.style.color = '#dc3545'}
                        onMouseOut={(e) => e.currentTarget.style.color = '#999'}
                    >
                        <CloseIcon />
                    </button>
                </div>

                <div className="ct-modal-body" style={{ padding: '20px' }}>
                    {children}
                </div>

            </div>
        </div>
    );
};

export default InfoModal;